'use client';

import './Ads.css';
import { useState } from 'react';
import { toast } from 'react-toastify';
import Image from 'next/image';
import contactApi from '../../services/contactApi';
import AdSlot from './components/AdSlot';


const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubscribe = async () => {
    if (!email || !email.includes('@')) {
      toast.error('Please enter a valid email.');
      return;
    }

    setLoading(true);

    try {
      const res = await contactApi.subscribeNewsletter({ email });

      if (res?.success) {
        toast.success(
          'Your request for subscribing to the newsletter has been submitted.'
        );
      } else {
        toast.error(
          res?.data?.message || 'Subscription failed. Please try again.'
        );
      }

      setEmail('');
    } catch (err) {
      toast.error('Subscription failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="subscribe-box">
      <Image
        src="/images/Ads/subscribe.png"
        alt=""
        fill
        sizes="(max-width: 1023px) 100vw, 360px"
        quality={60}
        className="subscribe-box-bg"
      />
      <div className="subscribe-box-content">
        <h2 className="subscribe-title">Subscribe to our Newsletter</h2>

        <p className="subscribe-txt">
          Join our newsletter and receive the latest updates directly into your inbox.
        </p>

        <input
          type="email"
          id="newsletter-email"
          name="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
          autoComplete="email"
        />

        <button type="submit" disabled={loading} onClick={handleSubscribe}>
          {loading ? (
            <span className="loading-content">
              <span className="spinner" /> Subscribing...
            </span>
          ) : (
            'Subscribe'
          )}
        </button>
      </div>
    </div>
  );
};

const SideAds = () => {
  return (
    <AdSlot
      slotKey="global_side_ads"
      containerClass="global_side_ads"
      className="global_side_ad_image"
      id="global_side_ad"
    />
  );
};

export {
  SideAds,
  Newsletter
};
